import axios from "axios";

export default axios.create({
  baseURL: "https://api.zarnigorbiolog.uz/v1",
});

// http://api.xasannosirov.uz/v1/swagger/index.html#
// http://test.zarnigorbiolog.uz/v1/swagger/index.html#
